import { render, staticRenderFns } from "./GInputCheckbox.vue?vue&type=template&id=618c969f&"
import script from "./GInputCheckbox.vue?vue&type=script&lang=js&"
export * from "./GInputCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports